require('./flated');
require('./bootstrap');
require('./dropdown-menu');
require('./register');
require('./request-catalogue.app');

import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

window.addEventListener("user-consent-updated", () => {
  // if (process.env.MIX_APP_ENV == "production") {

  //   const analytics = Analytics({
  //     app: 'digital-catalogue',
  //     plugins: [
  //       googleTagManager({
  //         containerId: 'GTM-MQL87WRN'
  //       })
  //     ]
  //   })

  //   /* Track a page view */
  //   analytics.page()

  // }

  const analytics = Analytics({
    app: 'digital-catalogue',
    plugins: [
      googleTagManager({
        containerId: 'GTM-MQL87WRN'
      })
    ]
  })

  analytics.page()
});

document.addEventListener('DOMContentLoaded', () => {
  const consent = JSON.parse(localStorage.getItem("user_cookie_consent"));
  if (consent) {
    const analytics = Analytics({
      app: 'digital-catalogue',
      plugins: [
        googleTagManager({
          containerId: 'GTM-MQL87WRN'
        })
      ]
    })

    analytics.page()
  }
  const alternates_bg = document.querySelectorAll('.bg-alternate');
  const no_of_alt_bg = alternates_bg.length;
  alternates_bg.forEach((el, index) => {
    const colorClass = 'bg-color-' + ((index % no_of_alt_bg) + 1);
    el.classList.add(colorClass);
  });
});
